<template>
  <b-card class="mt-5 mx-auto" style="max-width: 20rem">
    <ParentalControls />
  </b-card>
</template>

<script>
import ParentalControls from "@/components/ParentalControls";

export default {
  components: {
    ParentalControls
  }
};
</script>
